import { Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import BankDetails from "./pages/BankDetails";
import Products from "./pages/Products";
import Network from "./pages/Network";
import NetworkCommission from "./pages/NetworkCommission";
import Incentive from "./pages/Incentive";
import FAQs from "./pages/FAQs";
import FaqsView from "./pages/FaqsView";
import Underwriting from "./pages/Underwriting";
import BatchPaymentHistory from "./pages/BatchPaymentHistory";
import BatchEnrollmentAmaphilIdHistory from "./pages/BatchEnrollmentAmaphilIdHistory";
import BatchUtilizationsHistory from "./pages/BatchUtilizationsHistory";
import BatchPayoutHistory from "./pages/BatchPayoutHistory";
import Members from "./pages/Members";
import EmailVerificationNotice from "./pages/EmailVerificationNotice";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import IncentiveA from "./pages/IncentiveA";
import NotFound from "./pages/NotFound";
import ChangePassword from "./pages/ChangePassword";
import ChangeEmail from "./pages/ChangeEmail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import EmailVerification from "./pages/EmailVerification";
import Messages from "./pages/Messages";
import ContactUsMessages from "./pages/ContactUsMessages";
import SystemLogsRegister from "./pages/SystemLogsRegister";
import SystemLogsProductPurchase from "./pages/SystemLogsProductPurchase";
import SystemLogsUnderwriting from "./pages/SystemLogsUnderwriting";
import SystemSettings from "./pages/SystemSettings";
import SystemOauthUsers from "./pages/SystemOauthUsers";

export const publicRoutes = (
  <>
    <Route path="/" element={<Navigate to="/dashboard" replace />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/email-verification" element={<EmailVerification />} />
    <Route path="/verify-email" element={<VerifyEmail />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />
  </>
);

export const protectedRoutes = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/profile", element: <Profile /> },
  { path: "/change-password", element: <ChangePassword /> },
  { path: "/change-email", element: <ChangeEmail /> },
  { path: "/bank-details", element: <BankDetails /> },
  { path: "/products", element: <Products /> },
  { path: "/network", element: <Network /> },
  { path: "/network-commission", element: <NetworkCommission /> },
  { path: "/incentive", element: <Incentive /> },
  { path: "/messages", element: <Messages /> },
  { path: "/faqs", element: <FAQs /> },
  { path: "/faqs-view", element: <FaqsView /> },
  { path: "/underwriting", element: <Underwriting /> },
  { path: "/batch-payment-history", element: <BatchPaymentHistory /> },
  { path: "/batch-enrollment-amaphil-id-history", element: <BatchEnrollmentAmaphilIdHistory /> },
  { path: "/batch-utilizations-history", element: <BatchUtilizationsHistory /> },
  { path: "/batch-payout-history", element: <BatchPayoutHistory /> },
  { path: "/members", element: <Members /> },
  { path: "/incentive-a", element: <IncentiveA /> },
  { path: "/contact-us-messages", element: <ContactUsMessages /> },
  { path: "/system-logs/register", element: <SystemLogsRegister /> },
  { path: "/system-logs/product-purchase", element: <SystemLogsProductPurchase /> },
  { path: "/system-logs/underwriting", element: <SystemLogsUnderwriting /> },
  { path: "/system-settings", element: <SystemSettings /> },
  { path: "/system-oauth-users", element: <SystemOauthUsers /> },
  { path: "*", element: <NotFound /> },
];

export const wrapProtectedRoute = (route) => ({
  ...route,
  element: <ProtectedRoute>{route.element}</ProtectedRoute>,
});
